<template>
  <button class="sso-auth-button" @click="handleClick" type="button">
    <svg class="sso-icon" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C12.7279 15.75 15.75 12.7279 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM9 4.5C10.2426 4.5 11.25 5.50736 11.25 6.75C11.25 7.99264 10.2426 9 9 9C7.75736 9 6.75 7.99264 6.75 6.75C6.75 5.50736 7.75736 4.5 9 4.5ZM9 13.95C7.3125 13.95 5.82375 13.0913 4.95 11.7937C4.97625 10.4663 7.65 9.7125 9 9.7125C10.3425 9.7125 13.0238 10.4663 13.05 11.7937C12.1762 13.0913 10.6875 13.95 9 13.95Z"
        fill="currentColor"
      />
    </svg>
    <span class="sso-button-text">Continue with SSO</span>
  </button>
</template>

<script>
export default {
  methods: {
    handleClick() {
      this.$trackEvent('login.sso-button.click', {
        cta: 'sso-button'
      });
      this.$emit('click');
    }
  }
};
</script>

<style lang="scss" scoped>
.sso-auth-button {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  background: var(--transparent-white-5);
  border: 1px solid var(--transparent-white-5);
  border-radius: 8px;

  padding: 0 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.1);
  }

  .sso-icon {
    width: 18px;
    height: 18px;
    min-width: 18px;
    min-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--transparent-white-60);
    transform: scale(1.4);
  }

  .sso-button-text {
    font-family: 'Mulish', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: var(--transparent-white-60);
  }
}
</style>
